import React, { createContext, ReactNode, useMemo, useContext } from 'react';
import { CompaniesContext } from 'src/context/companies.context';
import { localGridPreferenceData } from 'src/services/global-variables';
import { TableContext } from './table.context';

interface GlobalContextProviderProps {
  children: ReactNode;
}

interface InitialStateProps {
  clearAllFilters: () => void;
}

const initialState: InitialStateProps = {
  clearAllFilters: () => {},
};

const GlobalContext = createContext(initialState);

const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({ children }) => {
  const { activeStatusFilter, activeOrInactiveFilter } = useContext(CompaniesContext);
  const { handleColumnSelect } = useContext(TableContext);

  const clearAllFilters = () => {
    const innerEvent = 'all';
    activeStatusFilter(innerEvent as unknown as React.FormEvent<HTMLInputElement>);
    activeOrInactiveFilter.current = innerEvent;
    handleColumnSelect(localGridPreferenceData[0].gridOptions.selectedColumns);
  };

  const globalValue = useMemo(
    () => ({
      clearAllFilters,
    }),
    [
      {
        clearAllFilters,
      },
    ],
  );

  return <GlobalContext.Provider value={globalValue}>{children}</GlobalContext.Provider>;
};

export { GlobalContext, GlobalContextProvider };
